import { render } from "./ProjectDeepDiveModal.vue?vue&type=template&id=2be20e9d&scoped=true"
import script from "./ProjectDeepDiveModal.vue?vue&type=script&lang=js"
export * from "./ProjectDeepDiveModal.vue?vue&type=script&lang=js"

import "./ProjectDeepDiveModal.vue?vue&type=style&index=0&id=2be20e9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be20e9d"]])

export default __exports__